import { useMemo } from "react"

import { Layout } from "antd"
import { useSelector } from "react-redux"
import { useLocation } from "react-router"

import Icon from "../../../../Icon"
import QuickLinkItem from "../../../GettingStartedPage/componets/QuickLinkItem"
import { getQuickList } from "../../utils/helpers/getQuickList"
import BusinessSideBar from "../BusinessSideBar"
import OnboardingSideBar from "../OnboardingSideBar"

import "../../styles.less"

const { Sider } = Layout

const SideBar = ({ showSubSteps }) => {
  const new_onboarding_finished = useSelector(
    (state) => state.auth?.userInfo?.new_onboarding_finished
  )
  const is_created_by_invitation = useSelector(
    (state) => state.auth.userInfo?.is_created_by_invitation
  )
  const { pathname } = useLocation()
  const segments = pathname.split("/")
  const path = segments[2] ?? ""

  const quickList = useMemo(() => getQuickList(`/${path}`), [path])

  return (
    <Sider width={344} className="ob-sider">
      {new_onboarding_finished || is_created_by_invitation ? (
        <BusinessSideBar showSubSteps={showSubSteps} />
      ) : (
        <OnboardingSideBar showSubSteps={showSubSteps} />
      )}

      <div className="ob-quick">
        <div className="ob-quick__title">Quick links</div>
        {quickList.map((i) => (
          <QuickLinkItem
            icon={<Icon type={i.icon} />}
            title={i.title}
            description={i.description}
            url={i.url}
            isRecommend={i.recommended}
          />
        ))}
      </div>
    </Sider>
  )
}

export default SideBar
